import { useNavigate } from 'react-router-dom';
import { Header } from 'pages/HomePublic/components/Header';
import fogueteEtapa1 from 'assets/img/2026/foguete_etapa1.png';

export function ConfirmacaoVotoEtapa2() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-100">
      <Header currentPage="avaliacao-etapa-2" />

      <main className="px-4 py-12 md:py-16">
        <div className="max-w-[1200px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <section className="max-w-[520px]">
            <h1 className="m-0 text-blue-bb-1 text-4xl md:text-5xl font-bold leading-tight">
              Seu voto foi registrado
            </h1>

            <p className="mt-6 mb-0 text-base md:text-lg text-gray-600 leading-relaxed">
              Parabéns por sua contribuição na escolha das iniciativas que representam o BB.
            </p>

            <button
              type="button"
              className="mt-8 bg-yellow-bb text-blue-bb border-0 rounded-lg px-8 py-3 text-sm font-extrabold cursor-pointer"
              onClick={() => navigate('/votacao-etapa-2')}
            >
              VER AVALIAÇÃO
            </button>
          </section>

          <section className="flex justify-center lg:justify-end">
            <img
              src={fogueteEtapa1}
              alt="Ilustração de foguete"
              className="w-full max-w-[460px] h-auto"
            />
          </section>
        </div>
      </main>
    </div>
  );
}
